// 1) + / - buttons
document.addEventListener('click', (e) => {
  const plus = e.target.closest('[data-card-qty-plus]');
  const minus = e.target.closest('[data-card-qty-minus]');
  if (!plus && !minus) return;

  const wrap = e.target.closest('[data-card-qty]');
  const input = wrap?.querySelector('input[name="quantity"]');
  if (!input) return;

  const min = parseInt(input.min || '1', 10);
  const current = parseInt(input.value || String(min), 10);

  let next = current;
  if (plus) next = current + 1;
  if (minus) next = Math.max(min, current - 1);

  input.value = String(next);

  // notify any listeners
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// 2) Ensure quantity is submitted to cart/add
document.addEventListener(
  'submit',
  (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    // only for cards that have our qty UI
    const qtyWrap = form.querySelector('[data-card-qty]');
    if (!qtyWrap) return;

    const qtyInput = qtyWrap.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const qty = Math.max(1, parseInt(qtyInput.value || '1', 10));
    qtyInput.value = String(qty);

    // Force a hidden quantity inside the form (FormData-safe)
    let hidden = form.querySelector('input[name="quantity"][data-card-hidden-qty]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.setAttribute('data-card-hidden-qty', 'true');
      form.appendChild(hidden);
    }
    hidden.value = String(qty);
  },
  true
);

// 3) Stock validation (show message, prevent add, don't disable buttons)
const getCardRoot = (el) => el?.closest('.card') || el?.closest('[data-card]') || el?.closest('.product-card') || el?.closest('li') || el;

const getStockFromCard = (root) => {
  const stockEl = root?.querySelector('.card-stock__count');
  if (!stockEl) return null;
  const n = parseInt((stockEl.textContent || '').trim(), 10);
  return Number.isFinite(n) ? n : null;
};

const ensureStockMsgEl = (root) => {
  let msg = root.querySelector('[data-card-stock-msg]');
  if (!msg) {
    // fallback: create it if you forgot to add it in liquid
    msg = document.createElement('div');
    msg.className = 'card-stock-msg';
    msg.setAttribute('data-card-stock-msg', 'true');
    msg.hidden = true;
    msg.innerHTML = `You can’t add more than <span data-card-stock-msg-max></span> to the cart.`;
    // insert near qty if possible, else at end of card
    const qtyWrap = root.querySelector('[data-card-qty]');
    if (qtyWrap?.parentNode) qtyWrap.parentNode.insertBefore(msg, qtyWrap);
    else root.appendChild(msg);
  }
  return msg;
};

const showStockMsg = (root, stock) => {
  const msg = ensureStockMsgEl(root);
  const maxEl = msg.querySelector('[data-card-stock-msg-max]');
  if (maxEl) maxEl.textContent = String(stock);
  msg.hidden = false;
};

const hideStockMsg = (root) => {
  const msg = root?.querySelector('[data-card-stock-msg]');
  if (msg) msg.hidden = true;
};

// Hide the message whenever qty changes (your +/- triggers input+change already)
document.addEventListener('input', (e) => {
  const input = e.target.closest('[data-card-qty] input[name="quantity"]');
  if (!input) return;
  const root = getCardRoot(input);
  hideStockMsg(root);
});

document.addEventListener('change', (e) => {
  const input = e.target.closest('[data-card-qty] input[name="quantity"]');
  if (!input) return;
  const root = getCardRoot(input);
  hideStockMsg(root);
});

// Validate on add-to-cart submit
document.addEventListener(
  'submit',
  (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const qtyWrap = form.querySelector('[data-card-qty]');
    if (!qtyWrap) return;

    const qtyInput = qtyWrap.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const root = getCardRoot(form);
    const stock = getStockFromCard(root);

    // If we can't read stock, don't block anything (keeps your current behavior)
    if (stock == null) return;

    const qty = Math.max(1, parseInt(qtyInput.value || '1', 10));

    // If exceeds stock -> show message + stop submit (no add to cart)
    if (qty > stock) {
      e.preventDefault();
      e.stopPropagation();
      showStockMsg(root, stock);
      return;
    }
  },
  true
);
